import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { App } from './App'
import '../styles/index.css'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Um editor não pode ficar refazendo requisições ao trocar de aba no meio de uma
      // edição. Revalidação é sob demanda, ou por evento do WebSocket.
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 30_000,
    },
  },
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </StrictMode>,
)
